import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import trackEvent from "../shared/ga/trackEvent";
import tooltips from "./tooltips";
import { SubmittedCount, SubmitCandidateLink } from "./styles/column-styles";

const ColumnHeader = ({
  id,
  title,
  submittedCandidates,
  newCandidatesLink,
  isRecruiter,
  cvLimitFull,
  cardsCount,
}) => {
  const onclickSubmitCandidate = () => {
    trackEvent(
      "Submit Candidate",
      "Kanban Board Submit",
      "Candidate submitted from kanban"
    );
  };

  const submittedCandidatesColumn = id === "submitted-candidates";

  if (submittedCandidatesColumn && cvLimitFull) {
    return (
      <div>
        {title}
        <SubmittedCount
          data-tip={tooltips.cvLimitFullTip}
          data-for="cv-limit-full"
        >
          <ReactTooltip
            place="right"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="cv-limit-full"
          />
          {submittedCandidates}
        </SubmittedCount>
      </div>
    );
  }
  if (submittedCandidatesColumn && isRecruiter) {
    return (
      <div>
        {title}
        <SubmittedCount>{submittedCandidates}</SubmittedCount>
        <SubmitCandidateLink
          href={newCandidatesLink}
          title="Submit Candidate"
          data-tip={tooltips.submitCandidate}
          data-for="submit-candidates"
          onClick={onclickSubmitCandidate}
        >
          <FontAwesomeIcon icon={faPlusCircle} />
          <ReactTooltip
            place="left"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="submit-candidates"
          />
        </SubmitCandidateLink>
      </div>
    );
  }
  if (submittedCandidatesColumn) {
    return (
      <div>
        {title} ({cardsCount})
        <SubmittedCount>{submittedCandidates}</SubmittedCount>
      </div>
    );
  }
  return (
    <div>
      {title} {!isRecruiter && `(${cardsCount})`}
    </div>
  );
};

ColumnHeader.propTypes = {
  cvLimitFull: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isRecruiter: PropTypes.bool,
  newCandidatesLink: PropTypes.string,
  submittedCandidates: PropTypes.string,
  title: PropTypes.string.isRequired,
  cardsCount: PropTypes.number,
};

ColumnHeader.defaultProps = {
  cvLimitFull: PropTypes.bool.isNull,
  isRecruiter: PropTypes.bool.isNull,
  newCandidatesLink: PropTypes.isNull,
  submittedCandidates: PropTypes.isNull,
  cardsCount: PropTypes.isNull,
};

export default ColumnHeader;
